import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";

const formatError = (detail) => {
  if (!detail) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-ink flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-8 font-heading font-black text-2xl tracking-tighter text-white">
          Juventudes <span className="text-gradient">Latentes</span>
        </Link>
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-white rounded-sm p-8"
        >
          <div className="w-12 h-12 rounded-sm bg-brand-magenta flex items-center justify-center">
            <Lock className="text-white" size={22} />
          </div>
          <h1 className="mt-5 font-heading text-2xl font-bold tracking-tight text-brand-ink">
            Acceso administración
          </h1>
          <p className="mt-1 text-sm text-brand-ink/60">Gestiona el blog y los mensajes.</p>

          {error && (
            <div data-testid="login-error" className="mt-4 text-sm text-red-600 bg-red-50 px-3 py-2 rounded-sm">
              {error}
            </div>
          )}

          <div className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-semibold text-brand-ink">Correo</label>
              <input
                required
                type="email"
                data-testid="login-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-brand-ink">Contraseña</label>
              <input
                required
                type="password"
                data-testid="login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 w-full border border-[#E5E5E5] rounded-sm px-4 py-2.5 outline-none focus:border-brand-magenta"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="mt-6 w-full bg-brand-ink text-white font-semibold py-3 rounded-sm hover:bg-brand-orange transition-colors disabled:opacity-60"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
